import { Badge } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

export const UpdatedBadge = () => {
    return <Badge type="new">{translate("si.common.updated")}</Badge>;
};
